import React from 'react';
import type { GettingStartedSteps as GettingStartedStepsType } from '@sy/ssr-types';
import GettingStartedSteps from '../../../components/GettingStartedSteps';
import { featureImages, type FeatureType } from '../../assets/imageImports';

interface GettingStartedStepsWrapperProps {
	feature: FeatureType;
	gettingStartedSteps: GettingStartedStepsType;
}

const GettingStartedStepsWrapper: React.FC<GettingStartedStepsWrapperProps> = ({
	feature,
	gettingStartedSteps,
}) => {
	const images = featureImages[feature];
	if (!images) {
		return null;
	}

	const stepImages = images.gettingStartedStepsImages;
	if (!stepImages) {
		return null;
	}

	const stepsWithImages = gettingStartedSteps.steps.map(step => ({
		imageSrc: stepImages[step.imageName as keyof typeof stepImages] || '',
		titleKey: step.titleKey,
		descriptionKey: step.descriptionKey,
	}));

	return (
		<GettingStartedSteps
			titleKey={gettingStartedSteps.titleKey}
			subtitleKey={gettingStartedSteps.subtitleKey}
			steps={stepsWithImages}
		/>
	);
};

export default GettingStartedStepsWrapper;
